/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EventResponse } from '../../models/event-response';

export interface EventsControllerUploadTitleImage$Params {
  id: string;
      body: {
'file'?: Blob;
}
}

export function eventsControllerUploadTitleImage(http: HttpClient, rootUrl: string, params: EventsControllerUploadTitleImage$Params, context?: HttpContext): Observable<StrictHttpResponse<EventResponse>> {
  const rb = new RequestBuilder(rootUrl, eventsControllerUploadTitleImage.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EventResponse>;
    })
  );
}

eventsControllerUploadTitleImage.PATH = '/events/admin/{id}/title-image';
